(() => {
  window.MedistikTheme = window.MedistikTheme || {};

  const quantityBoxSelector = '.qty-box';
  const quantityButtonSelector = `${quantityBoxSelector} .add, ${quantityBoxSelector} .sub`;
  const localeRoot = document.documentElement.dataset.localizationRoot?.replace(/\/$/, '') || '/';
  const nonLocalizedPathPrefixes = [
    '/admin',
    '/challenge',
    '/checkout',
    '/checkouts',
    '/cdn',
    '/localization',
    '/tools',
  ];

  function shouldLocalizePath(pathname) {
    if (localeRoot === '/') return false;
    if (pathname === localeRoot || pathname.startsWith(`${localeRoot}/`)) return false;

    return !nonLocalizedPathPrefixes.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    );
  }

  function localizeStorefrontLink(anchor) {
    if (!(anchor instanceof HTMLAnchorElement) || anchor.hasAttribute('download')) return;

    const href = anchor.getAttribute('href');
    if (!href || href.startsWith('#')) return;

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch {
      return;
    }

    if (!['http:', 'https:'].includes(url.protocol) || url.origin !== window.location.origin) return;
    if (!shouldLocalizePath(url.pathname)) return;

    url.pathname = `${localeRoot}${url.pathname === '/' ? '' : url.pathname}`;
    anchor.href = url.toString();
  }

  function localizeStorefrontLinks(root = document) {
    if (localeRoot === '/' || !root || typeof root.querySelectorAll !== 'function') return;
    root.querySelectorAll('a[href]').forEach(localizeStorefrontLink);
  }

  function quantityInput(box) {
    return box?.querySelector('input[type="number"][name="quantity"]');
  }

  function quantityBounds(input) {
    const configuredMin = Number(input.min);
    const configuredMax = Number(input.max);

    return {
      min: Number.isFinite(configuredMin) && configuredMin > 0 ? configuredMin : 1,
      max: input.max && Number.isFinite(configuredMax) ? configuredMax : Infinity,
    };
  }

  function updateQuantityButtons(box) {
    const input = quantityInput(box);
    if (!(input instanceof HTMLInputElement)) return;

    const { min, max } = quantityBounds(input);
    const value = Number(input.value) || min;
    const subtractButton = box.querySelector('.sub');
    const addButton = box.querySelector('.add');

    subtractButton?.toggleAttribute('disabled', value <= min);
    addButton?.toggleAttribute('disabled', value >= max);
    subtractButton?.setAttribute('aria-label', 'Decrease quantity');
    addButton?.setAttribute('aria-label', 'Increase quantity');
  }

  function setQuantity(box, value, emitEvents = true) {
    const input = quantityInput(box);
    if (!(input instanceof HTMLInputElement)) return;

    const { min, max } = quantityBounds(input);
    const nextValue = Math.min(max, Math.max(min, value));
    input.value = String(nextValue);
    if (emitEvents) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    updateQuantityButtons(box);
  }

  function initializeQuantityBoxes(root = document) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    root.querySelectorAll(quantityBoxSelector).forEach(updateQuantityButtons);
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    localizeStorefrontLink(event.target.closest('a[href]'));

    const button = event.target.closest(quantityButtonSelector);
    if (!(button instanceof HTMLButtonElement)) return;

    const box = button.closest(quantityBoxSelector);
    const input = quantityInput(box);
    if (!(input instanceof HTMLInputElement)) return;

    event.preventDefault();
    const direction = button.classList.contains('sub') ? -1 : 1;
    const step = Number(input.step) || 1;
    setQuantity(box, (Number(input.value) || 1) + direction * step);
  });

  document.addEventListener('change', (event) => {
    if (
      !(event.target instanceof HTMLInputElement) ||
      !event.target.matches(`${quantityBoxSelector} input[type="number"][name="quantity"]`)
    ) {
      return;
    }

    const box = event.target.closest(quantityBoxSelector);
    setQuantity(box, Number(event.target.value) || 1, false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeQuantityBoxes();
        localizeStorefrontLinks();
      },
      { once: true },
    );
  } else {
    initializeQuantityBoxes();
    localizeStorefrontLinks();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeQuantityBoxes(event.target);
    localizeStorefrontLinks(event.target);
  });
})();

function addPageLoadedClass() {
    document.body.classList.add("page-loaded");
    window.removeEventListener("scroll", onFirstInteraction);
    window.removeEventListener("keydown", onFirstInteraction);
    window.removeEventListener("mousemove", onFirstInteraction);
    window.removeEventListener("touchstart", onFirstInteraction);
    window.removeEventListener("click", onFirstInteraction);
}

function onFirstInteraction() {
    addPageLoadedClass();
}

window.addEventListener("scroll", onFirstInteraction, { once: true });
window.addEventListener("keydown", onFirstInteraction, { once: true });
window.addEventListener("mousemove", onFirstInteraction, { once: true });
window.addEventListener("touchstart", onFirstInteraction, { once: true });
window.addEventListener("click", onFirstInteraction, { once: true });
